import { NavLink } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useAuth } from '../hooks/useAuth'

export default function Sidebar() {
  const { t } = useTranslation()
  const { user, logout } = useAuth()

  return (
    <aside className="a-sidebar">
      {/* Logo */}
      <div className="a-logo">
        <div className="a-logo-icon">
          <i className="bi bi-file-text"></i>
        </div>
        <div className="a-logo-text">
          Adder <em>Contracts</em>
        </div>
      </div>

      {/* Navigation */}
      <nav className="a-nav">
        <div className="a-nav-section">
          <div className="a-nav-label">{t('nav.dashboard')}</div>
          <NavLink to="/dashboard" className={({ isActive }) => `a-nav-link ${isActive ? 'active' : ''}`}>
            <i className="bi bi-speedometer2"></i>
            {t('nav.dashboard')}
          </NavLink>
        </div>

        <div className="a-nav-section">
          <div className="a-nav-label">Gestión</div>
          <NavLink to="/contracts" className={({ isActive }) => `a-nav-link ${isActive ? 'active' : ''}`}>
            <i className="bi bi-file-earmark-text"></i>
            {t('nav.contracts')}
          </NavLink>
          <NavLink to="/templates" className={({ isActive }) => `a-nav-link ${isActive ? 'active' : ''}`}>
            <i className="bi bi-files"></i>
            {t('nav.templates')}
          </NavLink>
          <NavLink to="/contract-types" className={({ isActive }) => `a-nav-link ${isActive ? 'active' : ''}`}>
            <i className="bi bi-tags"></i>
            {t('nav.contract_types')}
          </NavLink>
        </div>

        <div className="a-nav-section">
          <div className="a-nav-label">Configuración</div>
          <NavLink to="/settings" className={({ isActive }) => `a-nav-link ${isActive ? 'active' : ''}`}>
            <i className="bi bi-gear"></i>
            {t('nav.settings')}
          </NavLink>
          {user?.is_superadmin && (
            <NavLink to="/admin" className={({ isActive }) => `a-nav-link ${isActive ? 'active' : ''}`}>
              <i className="bi bi-shield-lock"></i>
              {t('nav.admin')}
            </NavLink>
          )}
        </div>
      </nav>

      {/* User */}
      <div className="a-user">
        <div className="a-user-row">
          <div className="a-avatar">
            {user?.name ? user.name.charAt(0).toUpperCase() : user?.email?.charAt(0).toUpperCase()}
          </div>
          <div className="a-user-info">
            <div className="a-user-name">{user?.name || user?.email}</div>
            <div className="a-user-email">{user?.email}</div>
          </div>
          <a className="a-logout" href="#" onClick={(e) => { e.preventDefault(); logout() }} title="Cerrar sesión">
            <i className="bi bi-box-arrow-right"></i>
          </a>
        </div>
      </div>
    </aside>
  )
}
